import React, { useState } from 'react';
import moment from 'moment';
import { SingleDatePicker } from 'react-dates';
import Duration from "../Duration";
import Button from "../Button";
import "./style.css"; // Global States for faster scheduling

import { useStore } from "../../contexts/store";

const SelectDays = ({
  clientSideRef,
  expertSideRef,
  changeDate
}) => {
  const {
    state
  } = useStore();
  const {
    dayToRender,
    selectedDate
  } = state;
  const [focus, setFocus] = useState(false);

  const onSetFocus = ({
    focused
  }) => {
    setFocus(focused);
  };

  const today = () => {
    clientSideRef.current.getInstance().today();
    expertSideRef.current.getInstance().today();
    changeDate(moment());
  };

  const handlePrevNext = e => {
    const expert = expertSideRef.current.getInstance();
    const client = clientSideRef.current.getInstance();

    if (e.target.id === 'prev') {
      if (moment(client._renderDate._date).format('DD-MM-YYYY') !== moment().format('DD-MM-YYYY')) {
        expert.prev();
        client.prev();
        changeDate(moment(new Date(expert._renderDate)));
      }
    } else {
      expert.next();
      client.next();
      changeDate(moment(new Date(expert._renderDate)));
    }
  };

  const getClientDateDetails = date => {
    const availabilities = filterAvailableDate(clientSideRef.current.props.schedules, date);
    return availabilities;
  };

  const getExpertDateDetails = date => {
    const availabilities = filterAvailableDate(expertSideRef.current.props.schedules, date);
    return availabilities;
  };

  const filterAvailableDate = (availabilities, date) => availabilities.filter(a => moment(a.start).format('DD MM YYYY') === date.format('DD MM YYYY'));

  const hasAvailability = (date, expert, client) => {
    let retval = false;
    expert.forEach(e => {
      client.forEach(c => {
        if (moment(date).format('DDMMYYYY') === moment(e.start).format('DDMMYYYY') || moment(date).format('DDMMYYYY') === moment(c.start).format('DDMMYYYY')) {
          const eStart = parseInt(moment(e.start).format('x'));
          const eEnd = parseInt(moment(e.end).format('x'));
          const cStart = parseInt(moment(c.start).format('x'));
          const cEnd = parseInt(moment(c.end).format('x'));

          if (Math.max(cEnd, eEnd) - Math.min(cStart, eStart) < eEnd - eStart + (cEnd - cStart)) {
            retval = true;
          }
        }
      });
    });
    return retval;
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, window && window.outerWidth < 768 ? /*#__PURE__*/React.createElement("div", {
    className: "selectDaysContainer_mobile"
  }, /*#__PURE__*/React.createElement(SingleDatePicker, {
    small: true,
    numberOfMonths: window.matchMedia('(max-width: 400px)').matches ? 1 : 2,
    orientation: window.matchMedia('(max-width: 400px)').matches ? 'horizontal' : 'vertical',
    date: dayToRender,
    onDateChange: changeDate,
    focused: focus,
    onFocusChange: focusedInput => onSetFocus(focusedInput),
    id: "pickDay",
    showDefaultInputIcon: true,
    inputIconPosition: "after",
    onClose: function noRefCheck() {},
    displayFormat: 'DD-MM-YYYY',
    renderDayContents: d => {
      const clientDetails = getClientDateDetails(d);
      const expertDetails = getExpertDateDetails(d);
      const clientAvailabilities = clientDetails;
      const expertAvailabilities = expertDetails;
      return /*#__PURE__*/React.createElement("div", {
        className: `day-cell`
      }, /*#__PURE__*/React.createElement("span", {
        className: "dayOfMonth"
      }, `${d.format('D')}`), /*#__PURE__*/React.createElement("div", {
        className: "dotContainer"
      }, clientAvailabilities.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "dotSD client mr1"
      }), expertAvailabilities.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "dotSD expert mr1"
      })));
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "buttonContainer"
  }, /*#__PURE__*/React.createElement(Duration, null), /*#__PURE__*/React.createElement("div", {
    className: "button-group buttonContainer_inner"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "button-part button-part_border",
    label: "Today",
    onClick: today
  }), /*#__PURE__*/React.createElement(Button, {
    className: "button-part button-part_border",
    label: "<",
    id: "prev",
    onClick: handlePrevNext
  }), /*#__PURE__*/React.createElement(Button, {
    className: "button-part button-part_border",
    label: ">",
    id: "next",
    onClick: handlePrevNext
  })))) : /*#__PURE__*/React.createElement("div", {
    className: "selectDaysContainer selectDays_wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "selectDaysContainer_inner"
  }, focus && /*#__PURE__*/React.createElement("div", {
    className: "calendarInfoCalendar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dotContainer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dotSD client"
  }), /*#__PURE__*/React.createElement("p", null, "Client")), /*#__PURE__*/React.createElement("div", {
    className: "dotContainer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dotSD expert"
  }), /*#__PURE__*/React.createElement("p", null, "Expert")), /*#__PURE__*/React.createElement("div", {
    className: "dotContainer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dotSD match"
  }), /*#__PURE__*/React.createElement("p", null, "Match"))), /*#__PURE__*/React.createElement(SingleDatePicker, {
    small: true,
    date: dayToRender,
    onDateChange: changeDate,
    focused: focus,
    onFocusChange: focusedInput => onSetFocus(focusedInput),
    id: "pickDay",
    showDefaultInputIcon: true,
    inputIconPosition: "after",
    onClose: function noRefCheck() {},
    displayFormat: 'DD-MM-YYYY',
    renderDayContents: d => {
      const clientDetails = getClientDateDetails(d);
      const expertDetails = getExpertDateDetails(d);
      const clientAvailabilities = clientDetails;
      const expertAvailabilities = expertDetails;
      return /*#__PURE__*/React.createElement("div", {
        className: `info ${hasAvailability(d, expertAvailabilities, clientAvailabilities) ? 'outline' : ''}`
      }, /*#__PURE__*/React.createElement("div", {
        className: `day-cell ${new Date(d).getDate() === new Date(selectedDate).getDate() && new Date(d).getMonth() === new Date(selectedDate).getMonth() ? 'selected' : ''}`
      }, /*#__PURE__*/React.createElement("span", {
        className: "dayOfMonth"
      }, `${d.format('D')}`), /*#__PURE__*/React.createElement("div", {
        className: "dayCellContainer"
      }, clientAvailabilities.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "dot client"
      }), expertAvailabilities.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "dot expert"
      }))));
    }
  }), /*#__PURE__*/React.createElement(Duration, null)), /*#__PURE__*/React.createElement("div", {
    className: "calendarView"
  }, /*#__PURE__*/React.createElement("button", {
    className: "myButton",
    onClick: today
  }, "Today"), /*#__PURE__*/React.createElement("button", {
    className: "prevNext",
    id: "prev",
    onClick: handlePrevNext
  }, "<"), /*#__PURE__*/React.createElement("button", {
    className: "prevNext",
    id: "next",
    onClick: handlePrevNext
  }, ">"))));
};

export default SelectDays;